const Masthead = {

	// Start: init
	init: function() {
		let search_input = $('.js-hidden-search');

		$('.js-search-toggler').on("click", function(e){
			e.preventDefault();
			if (search_input.hasClass("active")){
				search_input.removeClass("active");
			} else {
				search_input.addClass("active");
			}
		});

		$('#product_list').change(function() {
			let selectedIndex = this.selectedIndex;
			if(selectedIndex!=0) self.location=this.options[selectedIndex].value;
		});
	}
	// End: init

};

export default Masthead;